export default class CalendarFactory {
  constructor(start, end) {
    this.start = start
    this.end = end
    this.calendarList = []
  }

  new() {
    this.generateCalendar()
    return this.calendarList
  }

  generateCalendar() {
    var startDay = this.getMonthFirstDay(this.start.getDate(), this.start.getDay())
    var calendarList = []
    for (var d = new Date(this.start); d <= this.end; d.setMonth(d.getMonth() + 1)) {
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      var weeks;
      var result = this.generateMonth(month, startDay, year)
      weeks = result[0]
      startDay = result[1]
      calendarList.push({
        year: d.getFullYear(),
        month: month,
        weeks: weeks
      })
    }
    this.calendarList = calendarList
  }

  generateWeek(startDate, startDay, length) {
    var week = []
    for (var i = 0; i < 7; ++i) {
      if (i < startDay)
        week.push("")
      else {
        const date = startDate + i - startDay
        if (date > length)
          week.push("")
        else
          week.push(date)
      }
    }
    return week
  }

  generateMonth(month, startDay, year) {
    const length = this.getMonthLength(month, year)
    var monthList = []
    monthList.push(this.generateWeek(1, startDay, length))
    for (var i = 1 + 7 - startDay; i <= length; i += 7) {
      monthList.push(this.generateWeek(i, 0, length))
    }
    var nextDay = this.getMonthNextFirstDay(startDay, length)
    return [monthList, nextDay]
  }

  getMonthFirstDay(date, day) {
    var firstDay = day - (date - 1) % 7
    if (firstDay < 0) {
      firstDay = firstDay + 7
    }
    return firstDay
  }

  getMonthNextFirstDay(day, length) {
    var nextDay = day + length % 7
    if (nextDay >= 7) {
      nextDay = nextDay - 7
    }
    return nextDay
  }

  getMonthLength(month, year) {
    switch (month) {
      case 2:
        if (this.isLeapYear(year))
          return 29
        return 28
      case 1:
      case 3:
      case 5:
      case 7:
      case 8:
      case 10:
      case 12:
        return 31
      default:
        return 30
    }
  }

  isLeapYear(year) {
    return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
  }
}
